var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import PropTypes from 'prop-types';
import React, { Component } from 'react';
import cs from '../_util/classNames';
import Input from './input';
import IconEye from '../../icon/react-icon/IconEye';
import IconEyeInvisible from '../../icon/react-icon/IconEyeInvisible';
import { ConfigConsumer } from '../ConfigProvider';
var Password = /** @class */ (function (_super) {
    __extends(Password, _super);
    function Password(props) {
        var _this = _super.call(this, props) || this;
        _this.focus = function () {
            _this.input && _this.input.focus();
        };
        _this.blur = function () {
            _this.input && _this.input.blur();
        };
        _this.setVisibility = function (visibility) {
            if (!_this.props.disabled) {
                _this.setState({ visibility: visibility });
            }
        };
        _this.renderSearch = function (_a) {
            var _b;
            var getPrefixCls = _a.getPrefixCls;
            var _c = _this.props, className = _c.className, visibilityToggle = _c.visibilityToggle, rest = __rest(_c, ["className", "visibilityToggle"]);
            var visibility = _this.state.visibility;
            var prefixCls = getPrefixCls('input-password');
            var classNames = cs(className, prefixCls, (_b = {},
                _b[prefixCls + "-visibility"] = visibilityToggle,
                _b));
            var icon;
            if (visibilityToggle) {
                icon = visibility ? (React.createElement(IconEye, { onClick: function () { return _this.setVisibility(false); } })) : (React.createElement(IconEyeInvisible, { onClick: function () { return _this.setVisibility(true); } }));
            }
            return (React.createElement(Input, __assign({}, rest, { type: visibility ? 'text' : 'password', className: classNames, ref: function (ref) { return (_this.input = ref); }, suffix: icon })));
        };
        _this.state = {
            visibility: props.defaultVisibility || props.visibility,
        };
        return _this;
    }
    Password.getDerivedStateFromProps = function (nextProps) {
        if ('visibility' in nextProps) {
            return {
                visibility: nextProps.visibility,
            };
        }
        return null;
    };
    Password.prototype.render = function () {
        return React.createElement(ConfigConsumer, null, this.renderSearch);
    };
    Password.propTypes = {
        className: PropTypes.oneOfType([PropTypes.string, PropTypes.arrayOf(PropTypes.string)]),
        visibilityToggle: PropTypes.bool,
    };
    Password.defaultProps = {
        visibilityToggle: true,
    };
    return Password;
}(Component));
export default Password;
